export default [
  {
    path: '/fission',
    name: 'fission',
    component: resolve => require(['@/pages/activity/fission'], resolve)
  },
  {
    path: '/address-fission',
    name: 'addressFission',
    component: resolve =>
      require(['@/pages/activity/fission/components/AddAddress.vue'], resolve)
  },
  {
    path: '/fission/record',
    name: 'record',
    component: resolve =>
      require(['@/pages/activity/fission/components/Record.vue'], resolve)
  },
  {
    path: '/fission/logistics',
    name: 'logistics',
    component: resolve =>
      require(['@/pages/activity/fission/components/Logistics.vue'], resolve)
  },
  {
    path: '/fission/offline',
    name: 'offline',
    component: resolve =>
      require(['@/pages/activity/fission/components/unShow.vue'], resolve)
  },
  {
    path: '/fission/withdraw',
    name: 'withdraw',
    component: resolve =>
      require(['@/pages/activity/fission/withdraw.vue'], resolve)
  }
]
